export default __webpack_public_path__ + "static/banner-four-shape8-aa190de38a1b78b69ca230a2defe8f04.png";